export const GoogleMapApiConfig = 'AIzaSyByQ7gGqL2jGh-y_flN_pQGg_hIrUJ_luQ';